import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import classes from "./PromoSubscription.module.css";
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import SmallLoader from '../components/Loaders/SmallLoader';
import OTPInput from "react-otp-input";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaCheck } from "react-icons/fa";
// import { getPacks } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
// import { SendOtpAPI } from '../http/http';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import TermsModal from '../components/TermsModal';
import { confirmSubAPI, sendOtpApi, subscribeApi } from '../http/http';
import AutoRenewalModal from '../components/AutoRenewalModal';

const PromoSubsription = () => {
    const { t } = useTranslation();
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [extRef, setExtRef] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const [autoRenew, setAutoRenew] = useState(true);

    const [pack, setPack] = useState("Daily");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    useEffect(() => {
        if (userToken) {
            navigate("/home");
        }
    }, [userToken]);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4().substring(0, 25) });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e) => {
        e.preventDefault();

        try {
            if (msisdn?.trim().length == 0) {
                return;
            }

            setLoading(true);

            handleAutoSubscription().then(() => {
                setLoading(false);
                navigate("/subscription-processing", {
                    state: {
                        msisdn: msisdn
                    }
                })
            }).catch((error) => {
                setLoading(false);

                if (error?.response?.data?.status == 0) {
                    toast.error(t("93"));
                }
                else if (error?.response?.data?.status == 1) {
                    toast.error("Subscription Request is Already Submitted for this MSISDN");
                }
                else {
                    toast.error(t("86"));
                }
            });

        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);
            if (error?.response?.data?.status == 0) {
                toast.error(t("93"));
            }
            else if (error?.response?.data?.status == 1) {
                toast.error("Subscription Request is Already Submitted for this MSISDN");
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    const handleAutoSubscription = async () => {
        try {
            // setLoading(true);

            const response = await confirmSubAPI(msisdn, pack, extRef, autoRenew);

            return response;
            // setLoading(false);

            // navigate("/subscription-processing", {
            //     state: {
            //         msisdn: msisdn
            //     }
            // })

        } catch (error) {
            // setLoading(false);
            throw error;
            // if (error?.response?.data?.status == 0) {
            //     toast.error(t("93"));
            // }
            // else if (error?.response?.data?.status == 1) {
            //     toast.error(t("94"));
            // }
            // else {
            //     toast.error(t("86"));
            // }
        }
    }

    return (
        <>
            <div className={classes.container}>
                <h1 className={classes.heading}>
                    Welcome to the{" "}
                    <span style={{ color: '#3550dc' }}>Service.</span>{" "} Enter the MSISDN below and select pack and click on Subscribe button.
                </h1>
                <div className={classes.actions_box_container}>
                    <div className={classes.actions_box}>
                        <button className={`${classes.action_box} ${classes.active}`}>
                            {t("61")}
                        </button>
                    </div>
                </div>


                <form className={classes.form} onSubmit={handleFormSubmission}
                >
                    <div className={classes.username_field_form}>
                        <div className={classes.country_code}>
                            {/* <img src="/assets/images/cameroon.png" alt="flag" className={classes.flag} /> */}
                            <p className={classes.country_code_number}>+237</p>
                        </div>
                        <input
                            id="msisdn"
                            name="msisdn"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            autoFocus placeholder={t("62")} className={classes.input_field_username}
                            onChange={(e) => {
                                setMsisdn(e.target.value)
                            }}
                            value={msisdn}
                        />
                    </div>

                    <div className={classes.packs}>
                        <p className={classes.packs_heading}>{t("63")}</p>

                        <button type='button' className={`${classes.pack_box} `}
                            onClick={() => setPack("Daily")}
                        >
                            <span className={`${classes.pack_header} `}>{t("119")}</span>
                            {
                                pack === "Daily" ?
                                    <div className={`${classes.checked_radio}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} `}>
                                {t("130")}
                            </p>
                        </button>

                        <button type='button' className={`${classes.pack_box} `}
                            onClick={() => setPack("Weekly")}
                        >
                            <span className={`${classes.pack_header}`}>{t("120")}</span>
                            {
                                pack === "Weekly" ?
                                    <div className={`${classes.checked_radio} `}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} `}>
                                {t("131")}
                            </p>
                        </button>

                    </div>

                    {/* <div className={classes.check_box_container}>
                        <input type="checkbox" id="autorenew" name="Terms & Conditions" value="Terms"
                            className={classes.check_box} checked={autoRenew} onChange={(e) => setAutoRenew(e.target.checked)}
                        >
                        </input>
                        <label className={classes.check_box_label}>
                            <span className={classes.link} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setAutoRenewal(true)
                            }
                            }>{t("127")}</span>
                        </label>
                    </div> */}


                    <button type="submit"
                        disabled={loading}
                        className={classes.login_btn}>{
                            loading ? <SmallLoader style={{ border: "5px solid #fff" }} /> : t("61")
                        }</button>
                    {/* <div className={classes.footer}>
                        <p><span>&copy;</span> Rainboo Softmate {new Date().getFullYear()}</p>
                    </div> */}
                </form>

            </div>

        </>
    )
}

export default PromoSubsription